import React from "react";
import { Link } from "react-router-dom";
import useAuth from "Context/useAuth";
import { paths } from "Constant/paths";
import { CURRENT_YEAR, SOCIAL_LINKS } from "Constant/constants";
import { useTranslation } from "react-i18next";

export const PublicFooter = () => {
  const { t } = useTranslation();
  const { toggleContactSalesModal } = useAuth();
  return (
    <>
      <section className="bg-white pt-lg-16 pt-10 pb-lg-10 pb-6 bg-grey-50">
        <div className="container-xl">
          <div className="footer-top pb-5">
            <div className="row justify-content-center">
              <div className="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                <div className="d-flex flex-column row-gap-3">
                  <span className="text-lg font-semibold text-grey-500 text-uppercase">
                    Final Call
                  </span>
                  <h2 className="text-xl-8xl text-md-6xl text-sm-4xl text-2xl font-bold">
                    Transform Your Application Process Now Experience Unmatched
                    Automation, Instant Clarity, and Secure Collaboration—All in
                    One Platform.
                  </h2>

                  <div className="d-flex gap-1 ">
                    <Link
                      to={paths.registration}
                      className="btn btn-primary d-inline-block px-6 py-2 text-xl-md font-medium d-inline-flex align-items-center gap-1"
                    >
                      Get started
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer id="contact" className="bg-grey-900 text-white web-footer">
        <div className="container-xl pt-5 pb-3">
          <div className="footer-bottom py-4">
            <div className="d-flex flex-wrap justify-content-sm-between justify-content-center align-items-center gap-3">
              <div className="order-md-last text-sm-end text-center">
                <ul className="social-link m-0 p-0 d-inline-flex flex-wrap align-items-center gap-2">
                  <li>
                    <a
                      href={SOCIAL_LINKS.facebook}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="facebook"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0 0 14.201 3c-2.444 0-4.122 1.492-4.122 4.231v2.355H7.332v3.209h2.753v8.202h3.312z"
                          fill="currentColor"
                        />
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a
                      href={SOCIAL_LINKS.twitter}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="twitter"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M10.4883 14.651L15.25 21H22.25L14.3917 10.5223L20.9308 3H18.2808L13.1643 8.88578L8.75 3H1.75L9.26086 13.0145L2.31915 21H4.96917L10.4883 14.651ZM16.25 19L5.75 5H7.75L18.25 19H16.25Z"></path>
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a
                      href={SOCIAL_LINKS.instagram}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="instagram"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M11.999 7.377a4.623 4.623 0 1 0 0 9.248 4.623 4.623 0 0 0 0-9.248zm0 7.627a3.004 3.004 0 1 1 0-6.008 3.004 3.004 0 0 1 0 6.008z"
                          fill="currentColor"
                        />
                        <circle
                          cx="16.806"
                          cy="7.207"
                          r="1.078"
                          fill="currentColor"
                        />
                        <path
                          d="M20.533 6.111A4.605 4.605 0 0 0 17.9 3.479a6.606 6.606 0 0 0-2.186-.42c-.963-.042-1.268-.054-3.71-.054s-2.755 0-3.71.054a6.554 6.554 0 0 0-2.184.42 4.6 4.6 0 0 0-2.633 2.632 6.585 6.585 0 0 0-.419 2.186c-.043.962-.056 1.267-.056 3.71 0 2.442 0 2.753.056 3.71.015.748.156 1.486.419 2.187a4.61 4.61 0 0 0 2.634 2.632 6.584 6.584 0 0 0 2.185.45c.963.042 1.268.055 3.71.055s2.755 0 3.71-.055a6.615 6.615 0 0 0 2.186-.419 4.613 4.613 0 0 0 2.633-2.633c.263-.7.404-1.438.419-2.186.043-.962.056-1.267.056-3.71s0-2.753-.056-3.71a6.581 6.581 0 0 0-.421-2.217zm-1.218 9.532a5.043 5.043 0 0 1-.311 1.688 2.987 2.987 0 0 1-1.712 1.711 4.985 4.985 0 0 1-1.67.311c-.95.044-1.218.055-3.654.055-2.438 0-2.687 0-3.655-.055a4.96 4.96 0 0 1-1.669-.311 2.985 2.985 0 0 1-1.719-1.711 5.08 5.08 0 0 1-.311-1.669c-.043-.95-.053-1.218-.053-3.654 0-2.437 0-2.686.053-3.655a5.038 5.038 0 0 1 .311-1.687c.305-.789.93-1.41 1.719-1.712a5.01 5.01 0 0 1 1.669-.311c.951-.043 1.218-.055 3.655-.055s2.687 0 3.654.055a4.96 4.96 0 0 1 1.67.311 2.991 2.991 0 0 1 1.712 1.712 5.08 5.08 0 0 1 .311 1.669c.043.951.054 1.218.054 3.655 0 2.436 0 2.698-.043 3.654h-.011z"
                          fill="currentColor"
                        />
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a
                      href={SOCIAL_LINKS.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="linkedin"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          cx="4.983"
                          cy="5.009"
                          r="2.188"
                          fill="currentColor"
                        />
                        <path
                          d="M9.237 8.855v12.139h3.769v-6.003c0-1.584.298-3.118 2.262-3.118 1.937 0 1.961 1.811 1.961 3.218v5.904H21v-6.657c0-3.27-.704-5.783-4.526-5.783-1.835 0-3.065 1.007-3.568 1.96h-.051v-1.66H9.237zm-6.142 0H6.87v12.139H3.095z"
                          fill="currentColor"
                        />
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="text-center scroll-link">
                <ul className="footer-navbar-nav d-flex flex-wrap justify-content-center p-0 m-0">
                  {/* <li className="nav-item">
                    <Link className="nav-link" to={paths.jobs}>
                      {t("common.jobs")}
                    </Link>
                  </li> */}
                  <li className="nav-item">
                    <Link
                      to={paths.careers}
                      className="nav-link"
                      aria-label="careers"
                    >
                      {t("common.careers")}
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to={paths.dataSecurity}
                      className="nav-link"
                      aria-label="data-security"
                    >
                      Data Security
                    </Link>
                  </li>
                  <li className="nav-item">
                    <a
                      href={SOCIAL_LINKS.blog}
                      className="nav-link"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="blog"
                    >
                      Blog
                    </a>
                  </li>
                  <li className="nav-item">
                    <button
                      type="button"
                      className="nav-link"
                      onClick={toggleContactSalesModal}
                    >
                      Contact Us
                    </button>
                  </li>
                  {/* <li className="nav-item">
                    <Link to={paths.privacyPolicy} className="nav-link">
                      Privacy Policy
                    </Link>
                  </li> */}
                  {/* <li className="nav-item">
                    <Link to={paths.helpCenter} className="nav-link">
                      Help Center
                    </Link>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
          <div className="footer-copy py-4 border-top border-grey-800 text-center">
            <small className="small text-black-500">
              &copy; {`${CURRENT_YEAR}`} Campustask Software Tech
              Solutions Private Limited. All rights reserved.
            </small>
          </div>
        </div>
      </footer>
    </>
  );
};
